import {combineLatest} from 'rxjs';
import {filter, map, startWith} from 'rxjs/operators';
import {gt, numUtil} from '@/helper/num';
import {maoMsg$} from '@/raw/mao/index';
import {marginAccountsCache$} from './accounts-cache';
import type {ws} from '@/types';
type MAOMsg = ws.MAOMsg;

const MaxRiskLevelEr = 999; // 无借贷或者资产为0: --, 最大值只展示到 999
const MaxRiskLevel = '999';

const riskLevelEr$ = maoMsg$.pipe(
  filter((o: MAOMsg) => o.hasOwnProperty('riskLevelEr') && gt(o.riskLevelEr, 0)),
  map((o) => o.riskLevelEr),
  startWith('999')
);

export const marginTradeCrossRiskLevel$ = combineLatest([riskLevelEr$, marginAccountsCache$]).pipe(
  map(([riskLevelEr, wallets]) => {
    const hasDebt = wallets
      .toArray()
      .find((item: ws.MarginAccountRaw) => gt(item.borrowedEv, 0) || gt(item.cumInterestEv, 0));
    if (hasDebt) {
      return {
        riskLevelEr,
        riskLevel: gt(riskLevelEr, MaxRiskLevelEr) ? MaxRiskLevel : numUtil.floor(riskLevelEr, 2),
      };
    }
    return {
      riskLevelEr: '999',
      riskLevel: '--',
    };
  })
);
